module.exports = __webpack_public_path__ + "img/DSC_1147.c59dfc01.jpg";